import {createPortal} from 'react-dom'

const Portal = ({children, el = document.body}) => {
    return createPortal(children,el)
}

export default Portal